import { toast } from "sonner";
import { apiPost } from "@/lib/api";
import type { TierId } from "@/lib/tiers";

export type TierFilterValue = TierId | "none";
export type StatusFilterValue = "all" | "active" | "inactive";

export interface InfluencerFilterState {
  search: string;
  tiers: TierFilterValue[];
  status: StatusFilterValue;
  minSales: string;
  maxSales: string;
}

export const EMPTY_FILTERS: InfluencerFilterState = {
  search: "",
  tiers: [],
  status: "all",
  minSales: "",
  maxSales: "",
};

export function hasActiveFilters(f: InfluencerFilterState): boolean {
  return (
    f.search.trim() !== "" ||
    f.tiers.length > 0 ||
    f.status !== "all" ||
    f.minSales !== "" ||
    f.maxSales !== ""
  );
}

export function copyCoupon(coupon: string) {
  navigator.clipboard
    .writeText(coupon)
    .then(() => toast.success(`Cupom ${coupon} copiado!`))
    .catch(() => toast.error("Não foi possível copiar o cupom"));
}

/**
 * One-time Instagram avatar import for one influencer (admin-triggered).
 * Resolves to the stored avatar URL; throws with a user-facing message.
 */
export async function importInstagramAvatar(userId: string, force: boolean): Promise<string> {
  const res = await apiPost("/api/influencers/import-instagram-avatar", {
    user_id: userId,
    force,
  });
  const body = await res.json().catch(() => null);
  if (!res.ok) {
    throw new Error(body?.error || "Não foi possível importar o avatar");
  }
  return body.avatar_url as string;
}
